import React from "react";
import { Form, InputNumber } from "antd";

class ElectricalLossEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = () => {
    const info = this.formRef.current.getFieldsValue();
    return info;
  };

  // 设置Form的ref
  formRef = React.createRef();

  render() {
    const { info } = this.props;
    return (
      <Form ref={this.formRef}>
        <div style={{ display: "flex" }}>
          <Form.Item label="待机功率" name="standbyPower" initialValue={info && info.standbyPower}>
            <InputNumber
              min={0}
              max={100}
              style={{ width: "150px" }}
              // formatter={value => `${value}kW`}
              // parser={value => value.replace('kW', '')}
              precision={3}
            />
          </Form.Item>
          <span style={{ padding: "5px 0 0 5px" }}>kW</span>
        </div>
        <div style={{ display: "flex" }}>
          <Form.Item
            label="充电效率"
            name="chargingEfficiency"
            initialValue={info && info.chargingEfficiency}>
            <InputNumber
              min={0}
              max={100}
              style={{ width: "150px" }}
              // formatter={value => `${value}%`}
              // parser={value => value.replace('%', '')}
              precision={2}
            />
          </Form.Item>
          <span style={{ padding: "5px 0 0 5px" }}>%</span>
        </div>
      </Form>
    );
  }
}

export default ElectricalLossEdit;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/electricalLossEdit.js